window.addEventListener('DOMContentLoaded', function () {

    const closeModal = document.getElementById("later-btn");
    closeModal.onclick = function(){
        closeYouShouldUseMobileAppModal();
    };

    function isAndroid() {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.indexOf("android") > -1;
    }

    function isHuawei() {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.indexOf("huawei") > -1;
    }

    function isXiaomi() {
        const userAgent = navigator.userAgent.toLowerCase();
        return (
            userAgent.indexOf("xiaomi") > -1
        );
    }

    function isChina() {
        let isChina;
        try {
            isChina = window.location.pathname.split('/')[1] === 'cn';
        } catch (e) {
            isChina = false;
        }
        return isChina;
    }

    function isIOS() {
        const userAgent =  navigator.userAgent.toLowerCase();
        return (
          (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) ||
          userAgent.indexOf('ipad') > -1 ||
          userAgent.indexOf('iphone') > -1 ||
          userAgent.indexOf('ipod') > -1
        );
    }
    function closeYouShouldUseMobileAppModal() {
        localStorage.setItem('last-seen-mobile-popup', Date.now());
        const elt = document.getElementById('you-should-use-mobile-app');
        if (elt !== null) {
            elt.style.display = 'none';
        }
    }

    function openYouShouldUseMobileAppModal() {
        const lastSeen = localStorage.getItem('last-seen-mobile-popup');
        const _1hour = 3600000;
        if (lastSeen !== null && Date.now() - lastSeen < _1hour) {
            return;
        }
        let analyticsTarget = 'Google Play Store';
        let href = window.appArray.android;
        let link = document.getElementById('cta-download-app-link');
        if (isAndroid() || isIOS()) {
            if (isAndroid()) {
                if (window.appArray.apk.length) { href = window.appArray.apk; analyticsTarget = 'apk';} // apk
            } else if (isIOS()) {
                if (window.appArray.apple.length) { href = window.appArray.apple; analyticsTarget = 'Apple Store'; } // apple
            }

            link.setAttribute('href', href);
            link.setAttribute('data-analytics-param-target', analyticsTarget);

            const elt = document.getElementById('you-should-use-mobile-app');
            if (elt !== null) {
                elt.style.display = 'block';
            }
        } else {
            link.setAttribute('href', href);
            link.setAttribute('data-analytics-param-target', analyticsTarget);
        }
    }

    openYouShouldUseMobileAppModal();
});
